import { useTranslation } from 'react-i18next';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import { Box, ButtonBase } from '@mui/material';

import { StyledCustomLoader } from '~/components/ui/CustomLoader';
import { Text } from '~/components/ui/text/Text';

import * as S from '../styles';

export function UpdateButton({ isLoader, isDisbled, isUpdated, text, onClick }) {
  const { t } = useTranslation();
  return (
    <>
      <ButtonBase
        sx={S.updateBtn}
        className={isLoader ? 'loading static' : 'static'}
        disabled={isDisbled}
        onClick={onClick}
      >
        {isLoader ? <StyledCustomLoader /> : t('settings:update')}
      </ButtonBase>
      {isUpdated ? (
        <Box sx={S.updatedText}>
          <CheckCircleOutlineRoundedIcon htmlColor="var(--greenMain)" />
          <Text variant="button14Med" sx={{ color: 'var(--greenMain)' }}>
            {text}
          </Text>
        </Box>
      ) : null}
    </>
  );
}
